import { render, staticRenderFns } from "./ModalDetalheDuplicidade.vue?vue&type=template&id=34129001&lang=pug"
import script from "./ModalDetalheDuplicidade.vue?vue&type=script&lang=js"
export * from "./ModalDetalheDuplicidade.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalheDuplicidade.vue?vue&type=style&index=0&id=34129001&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports